import { Routes } from '@angular/router';

export default [
  {
    path: '**',
    loadComponent: () => import('./expertise.component').then((m) => m.ExpertiseComponent)
  }
] as Routes;
